import React, { useEffect, useState } from "react";
import app from "nystem";
import ReactDOM from "react-dom";

let portals = [];
let updatePortals = () => {};

const reactPortal = ({ id, Component, element, viewId }) => {
  portals = portals.filter(({ id: itemId }) => id !== itemId);

  if (Component) portals = [...portals, { id, Component, element, viewId }];

  updatePortals(portals);
};

const reactPortalViewClose = ({ id }) => {
  portals = portals.filter(({ viewId }) => id !== viewId);

  updatePortals(portals);
};

app.on(`reactPortal`, reactPortal);
app.on(`reactPortalViewClose`, reactPortalViewClose);

const TinymcePortal = () => {
  const [portalState, setPortalState] = useState(portals);

  useEffect(() => {
    updatePortals = setPortalState;
    setPortalState(portals);
    return () => {
      updatePortals = () => {};
    };
  }, []);

  if (portalState.length)
    return portalState.map(({ Component, element }) =>
      ReactDOM.createPortal(<Component />, element),
    );

  return null;
};

export default TinymcePortal;
